export default {
	"语言":"言語",
	"首页":"ホーム",
	"电影":"映画",
	"投票":"投票",
	"我的":"マイページ",
	"请求失败":"リクエスト失敗",
	"选妃":"お妃選び",
	"高端":"ハイエンド",
	"认证":"認証",
	"视频认证":"ビデオ認証",
	"收费区间":"料金範囲",
	"身高":"身長",
	"胸围":"バストサイズ",
	"服务城市：全国各地 航空运输：是":"サービスエリア：全国各地 航空輸送：あり",
	"我要约她":"彼女を予約する",
	"住所":"住所",
	"个人简介":"プロフィール",
	"请联系顾问或接待员":"アドバイザーまたは受付係にお問い合わせください",
	"全部":"すべて",
	"刷新成功":"更新成功",
	"尽享高端区":"ハイエンドゾーンを存分に楽しむ",
	"享受极致奢华体验":"究極のラグジュアリー体験を楽しむ",
	"空降":"緊急派遣",
	"查看更多":"もっと見る",
	"热门推荐":"人気おすすめ",
	"获取中":"取得中",
	"登录":"ログイン",
	"请输入用户名":"ユーザー名を入力してください",
	"请输入密码":"パスワードを入力してください",
	"忘记密码":"パスワードをお忘れですか？",
	"没有账户？马上注册":"アカウントがありませんか？今すぐ登録",
	"注册":"登録",
	"请输入用户名(6-12个英文字母或数字)":"ユーザー名を入力してください（6～12文字の英字または数字）",
	"请输入登录密码(6-12个英文字母或数字)":"ログインパスワードを入力してください（6～12文字の英字または数字）",
	"我已经知晓并同意开户协议各项条约":"口座開設規約に同意しました",
	"请输入邀请码":"招待コードを入力してください",
	"请勾选下方开户协议":"下の口座開設規約にチェックを入れてください",
	"投票结果":"投票結果",
	"提交":"提出",
	"当前选号":"現在の選択番号",
	"每注金额":"1回の賭け金額",
	"请输入金额":"金額を入力してください",
	"元":"円",
	"总共":"合計",
	"注":"口（賭け数）",
	"合计":"合計",
	"任务单":"ミッションリスト",
	"清空订单":"注文をクリア",
	"确认提交":"提出を確認",
	"期号":"期番号",
	"中奖号码":"当選番号",
	"鲜花":"コンドーム",
	"气球":"バイブレーター",
	"棒棒糖":"ローション",
	"烟花":"オナホール",
	"未选择":"未選択",
	"金额错误":"金額エラー",
	"请选号":"番号を選んでください",
	"请填写金额":"金額を入力してください",
	"余额不足，请联系客服充值":"残高不足です。カスタマーサポートにお問い合わせの上、チャージしてください",
	"未选中":"選択されていません",
	"请联系管理员领取该任务":"管理者に連絡してこのミッションを受け取ってください",
	"开奖成功，期号：":"抽選成功、期番号：",
	"请输入您的收款卡信息":"受取口座情報を入力してください",
	"银行卡号":"口座番号",
	"请输入真实银行卡号":"正しい銀行カード番号を入力してください",
	"银行名称":"銀行名",
	"请选择银行":"銀行を選択してください",
	"尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款":"お客様へ：資金の安全を確保するために、実名を登録し、出金パスワードを設定してください。名前が口座名義と一致しない場合、出金はできません",
	"确认绑卡":"カードを紐付ける",
	"请输入银行卡号":"銀行カード番号を入力してください",
	"任务记录":"ミッション履歴",
	"下注金额":"賭け金額",
	"下单时间":"注文時間",
	"结算时间":"決済時間",
	"充值":"チャージ",
	"提现":"出金",
	"我的钱包":"マイウォレット",
	"余额(元)":"残高（円）",
	"个人中心":"マイページ",
	"登录密码":"ログインパスワード",
	"系统公告":"システム通知",
	"在线客服":"オンラインカスタマーサポート",
	"请完成任务单后进入":"ミッションを完了してから進んでください",
	"请联系客服充值":"カスタマーサポートに連絡してチャージしてください",
	"请设置收款卡":"受取口座を設定してください",
	"功能已禁用":"機能が無効になっています",
	"账号下线":"アカウントがログアウトしました",
	"登录/注册":"ログイン/登録",
	"登录可享受更多服务":"ログインするとさらに多くのサービスを利用できます",
	"基本信息":"基本情報",
	"头像":"アバター",
	"选择头像":"アバターを選択",
	"确定":"確定",
	"取消":"キャンセル",
	"真实姓名":"本名",
	"未设置":"未設定",
	"性别":"性別",
	"男":"男性",
	"女":"女性",
	"未知":"不明",
	"绑定信息":"連携情報",
	"已绑定":"連携済み",
	"无":"なし",
	"收款卡信息":"受取口座情報",
	"添加收款卡":"受取口座を追加",
	"提示:请绑定大型商业银行,如需修改,请您联系在线客服":"注意：大手商業銀行を登録してください。変更が必要な場合は、オンラインカスタマーサポートにお問い合わせください",
	"请设置姓名后再绑定银行卡":"名前を設定した後に銀行カードを登録してください",
	"修改登录密码":"ログインパスワードの変更",
	"旧密码":"旧パスワード",
	"请输入您的旧密码":"旧パスワードを入力してください",
	"新密码":"新パスワード",
	"请输入您的新密码":"新しいパスワードを入力してください",
	"请再次输入您的新密码":"新しいパスワードをもう一度入力してください",
	"保存":"保存",
	"修改真实姓名":"本名を変更",
	"姓名":"名義人",
	"支行":"支店",
	"支店番号":"支店番号",
	"请输入真实姓名":"本名を入力してください",
	"为了您账户安全,真实姓名需要与绑定银行卡姓名一致":"アカウントの安全のため、本名は銀行カードの名義と一致する必要があります",
	"请勿重复设置":"繰り返し設定しないでください",
	"性别修改":"性別変更",
	"提现中心":"出金センター",
	"提现记录":"出金履歴",
	"提现金额(元)":"出金金額（円）",
	"1.单笔限额：最低":"1回の最低限度額：",
	"元，最高":"円、最大",
	"2.提现次数：一天最高提现":"2. 出金回数：1日最大",
	"次":"回",
	"3.到账时间：一般到账时间在5分钟左右，最快2分钟内到账":"3. 入金時間：通常5分程度、最短2分以内に反映",
	"限额说明":"限度額説明",
	"余额":"残高",
	"马上提现":"今すぐ出金",
	"请填写正确的金额":"正しい金額を入力してください",
	"数据为空":"データなし",
	"说明":"説明",
	"金额":"金額",
	"提交时间":"提出時間",
	"审核时间":"審査時間",
	"没有更多了":"これ以上ありません",
	"播放":"再生",
	"次播放":"回再生",
	"请充值后观看视频":"チャージ後に動画を視聴してください",
	"填写收款卡":"受取口座を入力してください",
	"选妃详情":"お妃選びの詳細",
	"视频":"ビデオ",
	"游戏":"ゲーム",
	"设置":"設定",
	"修改性别":"性別を変更",
	"登录密码管理":"ログインパスワード管理",
	"详情页面":"詳細ページ",
	"请填写完整":"すべて入力してください",
	"两次密码输入不一致":"2回入力したパスワードが一致しません",
	"写真":"写真",
	"现在预约":"今すぐ予約",
	"视频播放":"動画再生",
	"退出登录":"ログアウト",
	
	"余额不足":"残高不足",
	"扣款失败":"引き落とし失敗",
	"下注异常":"ベット異常",
	"投注成功":"ベット成功",
	"参数异常":"パラメータ異常",
	"数据不存在":"データが存在しません",
	"数据获取失败":"データ取得失敗",
	"数据获取成功":"データ取得成功",
	"鉴权错误":"認証エラー",
	"更换头像成功":"アバター変更成功",
	"更新头像失败":"アバター更新失敗",
	"请输入真实姓名后再填写银行卡":"本名を入力した後に銀行カード情報を記入してください",
	"请输入提现密码后再填写银行卡":"出金パスワードを設定した後に銀行カード情報を記入してください",
	"已设置过银行卡":"銀行カードはすでに設定済みです",
	"设置银行卡成功":"銀行カード設定成功",
	"设置银行卡失败":"銀行カード設定失敗",
	"设置提现密码成功":"出金パスワード設定成功",
	"设置提现密码失败":"出金パスワード設定失敗",
	"修改密码成功":"パスワード変更成功",
	"修改密码失败":"パスワード変更失敗",
	"设置姓名成功":"名前設定成功",
	"设置姓名失败":"名前設定失敗",
	"设置性别成功":"性別設定成功",
	"设置性别失败":"性別設定失敗",
	"打码量不足":"賭け金額が不足しています",
	"提现金额不能少于":"出金金額は以下にできません",
	"提现金额不能大于":"出金金額は以下を超えることはできません",
	"当日提现次数已用完":"本日の出金回数は上限に達しました",
	"余额不足":"残高不足",
	"提现失败":"出金失敗",
	"提现成功":"出金成功",
	"扣款失败":"引き落とし失敗",
	"结算中":"決済中",
	"已结算":"決済完了",
	"盈利":"利益",
	"亏损":"損失",
	"待结算":"決済待ち",
	"获取信息成功":"情報取得成功",
	"待审核":"審査待ち",
	"审核成功":"審査成功",
	"审核退回":"審査差し戻し",
	"网络异常，请重新登录":"ネットワーク異常です。再度ログインしてください",
	"用户不存在":"ユーザーが存在しません",
	"密码错误":"パスワードが間違っています",
	"账号被禁用":"アカウントが凍結されています",
	"登录成功":"ログイン成功",
	"用户名不能存在中文":"ユーザー名には中国語を含めることはできません",
	"用户名位数错误":"ユーザー名の桁数が正しくありません",
	"密码位数错误":"パスワードの桁数が正しくありません",
	"邀请码不能为空":"招待コードは空にできません",
	"邀请码不存在":"招待コードが存在しません",
	"注册成功":"登録成功",
	"注册失败":"登録失敗",
	"用户已存在":"ユーザーはすでに存在しています",
}
